import { createSlice, current } from '@reduxjs/toolkit';
import { getCategories, addCategory, updateCategory, deleteCategory } from '../thunks/categories';

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    isFetching: false,
    isAdding: false,
    isUpdating: {},
  },

  reducers: {},

  extraReducers: {
    [getCategories.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getCategories.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.categories = action.payload;
    },
    [getCategories.rejected]: (state, action) => {
      state.isFetching = false;
    },

    [addCategory.pending]: (state, action) => {
      state.isAdding = true;
    },
    [addCategory.fulfilled]: (state, action) => {
      state.categories.push(action.payload);
      state.isAdding = false;
    },
    [addCategory.rejected]: (state, action) => {
      state.isAdding = false;
    },

    [updateCategory.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = true;
    },
    [updateCategory.fulfilled]: (state, action) => {
      const { _id, name } = action.payload;
      const currentState = current(state);
      state.categories = currentState.categories.map(category => category._id === _id ? { ...category, name } : category);
      state.isUpdating[_id] = false;
    },
    [updateCategory.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = false;
    },

    [deleteCategory.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.categories = currentState.categories.filter(category => category._id !== action.payload);
    }
  }
});

export default categoriesSlice.reducer;
